export const telMask = (value:string) => {
      value += '';
      if(value.length > 10){
            let numeros = value.split("");
            let ddd = "(" + numeros[0] + numeros[1] + ") ";
            let tel = numeros[2] + numeros[3] + numeros[4] + numeros[5] + numeros[6] + "-" + numeros[7] + numeros[8] + numeros[9] + numeros[10];      
      }else{
            let numeros = value.split("");
            let ddd = "(" + numeros[0] + numeros[1] + ") ";
            let tel = numeros[2] + numeros[3] + numeros[4] + numeros[5] + "-" + numeros[6]  + numeros[7] + numeros[8] + numeros[9];      
      }

      return value;
}